<template>
  <v-row>
    <v-col cols="4" v-for="{ name, icon, link } in links" :key="icon" class="link">
      <a :href="link">
        <div class="icon">
          <v-icon :color="brand.colors.usefulLinksIcon" :size="$vuetify.breakpoint.smAndDown ? 20 : 35">{{
            icon
          }}</v-icon>
        </div>
        <div class="text">
          {{ name }}
        </div>
      </a>
    </v-col>
  </v-row>
</template>

<script>
import brandMixin from '@/mixins/brandMixin'

export default {
  name: 'UsefulLinks',
  mixins: [brandMixin],
  data() {
    return {
      links: [
        {
          name: 'Laboratórios',
          icon: 'mdi-store'
        },
        {
          name: 'Estilo de vida',
          icon: 'mdi-weight-lifter'
        },
        {
          name: 'Seguro de vida',
          icon: 'mdi-human-male-female-child'
        },
        {
          name: 'Sinais Vitais',
          icon: 'mdi-heart-pulse'
        },
        {
          name: 'Farmácias',
          icon: 'mdi-hospital-box-outline'
        },
        {
          name: 'Exames',
          icon: 'mdi-file-document-multiple-outline'
        }
      ]
    }
  },
}
</script>

<style scoped>
.link {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.link a {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
}
.icon {
  width: 50px;
  height: 50px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-bottom: 10px;
}
.text {
  color: #818181;
  font-size: 0.75rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
}

@media only screen and (min-width: 960px) {
  .text {
    font-size: 0.9rem;
  }
  .icon {
    width: 70px;
    height: 70px;
  }
}
</style>
